import React, {Component} from 'react';
import { Row, Col, Card, CardTitle, CardBody, Button } from 'reactstrap';
import DateRangePicker from 'react-bootstrap-daterangepicker';
import BootstrapTable from 'react-bootstrap-table-next';
import { Bar } from 'react-chartjs-2';
import moment from 'moment';

import Config from '../../config';

import './AccountBook.css';

class AccountBook extends Component {
 constructor(props) {
  super(props);

  this.state = {
   start: moment().subtract(14, 'days'),
   end: moment(),
   tabledata: [],
   chartdata: {}
  }
 }

 getResume() {
  this.props.reqAPI(Config.apiURI+'/api/orders/resume', 'POST', {
   start: this.state.start.format('YYYY-MM-DD'),
   end: this.state.end.format('YYYY-MM-DD')
  }).then((data) => {
   var labels = [];
   var totalIN = [];
   var totalOUT = [];
   var tableDATA = [];
   Object.keys(data).map(function(key) {
    labels.push(data[key].label1);
    totalIN.push(data[key].cashIN + data[key].bankIN);
    totalOUT.push(data[key].cashOUT + data[key].bankOUT);
    tableDATA.push({...data[key], ...{totalCash: data[key].cashIN + (data[key].cashOUT * -1), totalBank: data[key].bankIN + (data[key].bankOUT * -1)}});
   });

   this.setState({
    tabledata: tableDATA.reverse(),
    chartdata: {
     labels: labels,
     datasets: [{
      label: 'Entrada',
      borderColor: '#70b27b',
      backgroundColor: '#70b27b',
      yAxisID: 'y-axis-1',
      data: totalIN
     }, {
      label: 'Salida',
      borderColor: '#bc4b4b',
      backgroundColor: '#bc4b4b',
      yAxisID: 'y-axis-2',
      data: totalOUT
     }]
    }
   });
  }).catch((error) => {
   console.log(error);
  })
 }

 componentWillMount() {
  this.getResume();
 }

 render() {
  if(this.state.start === this.state.end) {
   var humanDate = new Date(Date.parse(this.state.start)).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  } else {
   var humanDate = new Date(Date.parse(this.state.start)).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
   humanDate += ' - ' + new Date(Date.parse(this.state.end)).toLocaleDateString('es-ES', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' });
  }

  return (
   <Card>
    <CardBody>
     <Row>
      <Col sm="10">
       <CardTitle className="mb-0">Resumen de ventas</CardTitle>
       <div className="small text-muted font-weight-bold">{humanDate}</div>
      </Col>
      <Col sm="2" className="d-none d-sm-inline-block">
       <Button className="float-right" title="Reset" onClick={() => {
        this.setState({
         start: moment().subtract(14, 'days'),
         end: moment(),
         tabledata: [],
         chartdata: {}
        }, this.getResume);
       }}><i className="fa fa-refresh"></i></Button>
       <DateRangePicker
        opens="left"
        alwaysShowCalendars
        containerStyles={{'float':'right'}}
        startDate={moment().subtract(30, 'days')}
        endDate={moment()}
        locale={{
         format: 'DD/MM/YYYY',
         applyLabel: "Aplicar",
         cancelLabel: "Cancelar",
         customRangeLabel: "Personalizado",
         fromLabel: "De",
         toLabel: "a",
         weekLabel: "W",
         daysOfWeek: [ "Lu", "Ma", "Mi", "Ju", "Vi", "Sa", "Do" ],
         monthNames: [ "Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre" ],
         firstDay: 1
        }}
        onApply={(e, picker) => {
         this.setState({
          start: picker.startDate,
          end: picker.endDate
         }, this.getResume);
        }}><Button color="primary"><i className="fa fa-calendar"></i></Button>
       </DateRangePicker>
      </Col>
     </Row>
      
     <div className="chart-wrapper" height={160} style={{height: '160px', marginTop: '20px'}}>
      <Bar data={this.state.chartdata} options={{
       elements: { line: { fill: false } },
       maintainAspectRatio: false,
       legend: { display: false },
       tooltips: {
        mode: 'label',
        callbacks: {
         label: function(tooltipItem, data) {
          return data.datasets[tooltipItem.datasetIndex].label  + ': '+ data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index].toFixed(2) + '€';
         }
        }
       },
       scales: {
        xAxes: [{
         display: false,
        }],
        yAxes: [{
         type: 'linear',
         display: true,
         position: 'left',
         id: 'y-axis-1'
        }, {
         type: 'linear',
         display: true,
         position: 'right',
         id: 'y-axis-2'
        }],
       }
      }} />
     </div>
    </CardBody>

    <BootstrapTable
     striped
     condensed
     bootstrap4
     classes='booktable'
     keyField='label2'
     bordered={ false }
     data={this.state.tabledata}
     noDataIndication='No se han encontrado datos'
     columns={[{
      dataField: 'label2',
      text: 'Fecha'
     }, {
      dataField: 'cashIN',
      text: 'Entrada Efectivo',
      formatter: (value) => {
       return value.toFixed(2) + '€';
      },
      style: (colum, colIndex) => {
       return { width: '100px', textAlign: 'center', backgroundColor: 'rgba(164, 212, 177, .75)', borderLeft: '1px solid #a4b7c1' };
      },
      headerStyle: (colum, colIndex) => {
       return { width: '100px', textAlign: 'center' };
      }
     }, {
      dataField: 'bankIN',
      text: 'Entrada Tarjeta',
      formatter: (value) => {
       return value.toFixed(2) + '€';
      },
      style: (colum, colIndex) => {
       return { width: '100px', textAlign: 'center', backgroundColor: 'rgba(164, 212, 177, .75)', borderLeft: '1px solid #a4b7c1' };
      },
      headerStyle: (colum, colIndex) => {
       return { width: '100px', textAlign: 'center' };
      }
     }, {
      dataField: 'cashOUT',
      text: 'Salida Efectivo',
      formatter: (value) => {
       return value.toFixed(2) + '€';
      },
      style: (colum, colIndex) => {
       return { width: '100px', textAlign: 'center', backgroundColor: 'rgba(222, 125, 125, .75)', borderLeft: '1px solid #a4b7c1' };
      },
      headerStyle: (colum, colIndex) => {
       return { width: '100px', textAlign: 'center' };
      }
     }, {
      dataField: 'bankOUT',
      text: 'Salida Tarjeta',
      formatter: (value) => {
       return value.toFixed(2) + '€';
      },
      style: (colum, colIndex) => {
       return { width: '100px', textAlign: 'center', backgroundColor: 'rgba(222, 125, 125, .75)', borderLeft: '1px solid #a4b7c1' };
      },
      headerStyle: (colum, colIndex) => {
       return { width: '100px', textAlign: 'center' };
      }
     }, {
      dataField: 'totalCash',
      text: 'Total Efectivo',
      formatter: (value) => {
       return value.toFixed(2) + '€';
      },
      style: (colum, colIndex) => {
       return { width: '100px', textAlign: 'center', borderLeft: '1px solid #a4b7c1' };
      },
      headerStyle: (colum, colIndex) => {
       return { width: '100px', textAlign: 'center' };
      }
     }, {
      dataField: 'totalBank',
      text: 'Total Tarjeta',
      formatter: (value) => {
       return value.toFixed(2) + '€';
      },
      style: (colum, colIndex) => {
       return { width: '100px', textAlign: 'center', borderLeft: '1px solid #a4b7c1' };
      },
      headerStyle: (colum, colIndex) => {
       return { width: '100px', textAlign: 'center' };
      }
    }]} />
   </Card>
  )
 }
}

export default AccountBook;



// WEBPACK FOOTER //
// ./src/views/Orders/AccountBook.js